<template>
  <div class="container_view">
    <v-card class="content_card" elevation="10" variant="flat">
      <div>
        <header>
          <v-card-title> Avisos </v-card-title>
          <v-divider class="mx-3"></v-divider>
        </header>
      </div>
      <div class="content_accion">
        <div>
          <v-text-field
            v-model="search"
            label="Búsqueda"
            prepend-inner-icon="mdi-magnify"
            single-line
            variant="outlined"
            hide-details
            class="filter"
          ></v-text-field>
        </div>
        <div>
          <v-btn
            icon="mdi-reload"
            size="small"
            variant="outlined"
            color="indigo-darken-3"
            class="mr-2"
            @click="getAvisosAsignados"
          >
          </v-btn>
        </div>
      </div>
      <div class="container_table">
        <v-data-table
          class="content_table"
          :headers="headersAvisosAsignados"
          fixed-header
          :items="listAvisosAsignados"
          :search="search"
          :loading="loadingAvisosAsignados"
        >
        </v-data-table>
      </div>
    </v-card>
    <AlertComponent :value="dialogData" />
    <SnackbarComponent :value="snackbarData" />
  </div>
</template>

<script>
import { NoticeService } from "@/services/NoticesService";
import AlertComponent from "@/components/Alert.vue";
import SnackbarComponent from "@/components/Snackbar.vue";

export default {
  name: "NoticeGestorColabComponent",
  components: {
    AlertComponent,
    SnackbarComponent,
  },
  data() {
    return {
      listAvisosAsignados: [],
      loadingAvisosAsignados: true,
      search: "",
      headersAvisosAsignados: [
        { title: "Título", key: "titulo" },
        { title: "Descripción", key: "descripcion" },
        { title: "Autor", key: "autor" },
      ],
      dialogData: {
        openDialog: false,
        title: "",
        description: "",
        icon: "",
      },
      snackbarData: {
        openSnackbar: false,
        description: "",
      },
    };
  },
  beforeMount() {
    this.getAvisosAsignados();
  },
  methods: {
    getAvisosAsignados: async function () {
      let idU = await NoticeService.encriptar(localStorage.getItem("ID"));
      this.loadingAvisosAsignados = true;
      await NoticeService.getNoticesByUser(idU.msg)
        .then((resp) => {
          if (!resp.error) {
            this.listAvisosAsignados = resp.response;
            setTimeout(() => {
              this.loadingAvisosAsignados = false;
            }, 1000);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
    },
  },
};
</script>

<style scoped>
.filter {
  width: 300px;
}

.content_table {
  overflow: auto;
}

.content_accion {
  padding-bottom: 10px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}

.actions {
  display: flex;
  align-items: center;
  float: left;
  margin-right: 1vh;
  width: 9vh !important;
  height: 9vh !important;
}

.close {
  margin-right: 2vh;
}

.description-text {
  display: flex;
  justify-content: center;
}
.description-text p {
  width: 90%;
  text-align: center;
}

img {
  height: 230px;
  width: auto;
  padding: 40px;
}

.content_load {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
}
</style>
